var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"nav-button"}},[_c('icon',{attrs:{"size":"sm","icon":_vm.icon,"colour":"white"},nativeOn:{"click":function($event){return _vm.toggleLessonNav($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }